/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/filter.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a4f8d7fc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "patrol-guard-page"
};
var _hoisted_2 = {
  class: "patrol-guard-top"
};
var _hoisted_3 = {
  key: 0,
  class: "footer-left-tag-ing footer-left-tag"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "进行中", -1);
});
var _hoisted_5 = [_hoisted_4];
var _hoisted_6 = {
  key: 1,
  class: "footer-left-tag-cancel footer-left-tag"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "已取消", -1);
});
var _hoisted_8 = [_hoisted_7];
var _hoisted_9 = {
  key: 2,
  class: "footer-left-tag-expect footer-left-tag"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "已逾期", -1);
});
var _hoisted_11 = [_hoisted_10];
var _hoisted_12 = {
  key: 3,
  class: "footer-left-tag-complete footer-left-tag"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "已完成", -1);
});
var _hoisted_14 = [_hoisted_13];
var _hoisted_15 = {
  key: 4,
  class: "footer-left-tag-cancel footer-left-tag"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "未处理", -1);
});
var _hoisted_17 = [_hoisted_16];
var _hoisted_18 = {
  class: "footer-right"
};
var _hoisted_19 = {
  class: "popup-content"
};
var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = {
  key: 1
};
var _hoisted_22 = {
  class: "popup-btn"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-top-title"
  }, "更多筛选", -1);
});
var _hoisted_25 = {
  class: "patrol-guard-filter"
};
var _hoisted_26 = {
  class: "filter-content"
};
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "设备名称", -1);
});
var _hoisted_28 = {
  class: "filter-content"
};
var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "计划类型", -1);
});
var _hoisted_30 = {
  class: "filter-content"
};
var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "设备类型", -1);
});
var _hoisted_32 = {
  class: "filter-content"
};
var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "任务状态", -1);
});
var _hoisted_34 = {
  class: "filter-content-once"
};
var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "巡保人", -1);
});
var _hoisted_36 = {
  class: "popup-btn filter-action-btn"
};
import CollapseList from './CollapseList.vue';
import { getPatrolGuard, delPatrolGuard, cancelPatrolGuard } from '@/service/patrolGuard/index';
import { getDeviceType } from '@/service/deviceInfo/index';
import { useStore } from '@/store';
import { showToast } from 'vant';
import './index.less';
import './common.less';
var __default__ = {
  name: 'PatrolGuard'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var router = useRouter();
    // const route = useRoute();
    var store = useStore();
    // const list = ref<any[]>([]);
    var searchVal = ref('');
    var radioModalShow = ref(false);
    var customPopupType = ref();
    var filterModalShow = ref(false);
    // const actionType = ref<CusPopupType>();
    // 设备名称
    var deviceName = ref('');
    // 巡保人
    var inspectionUserName = ref('');
    // 任务类型
    var taskType = reactive({
      value: null,
      label: ''
    });
    var showTaskPicker = ref(false);
    var taskColumns = [{
      value: 0,
      text: '巡检计划'
    }, {
      value: 1,
      text: '保养计划'
    }];
    //任务状态
    var taskStatus = reactive({
      value: null,
      label: ''
    });
    var showStatusPicker = ref(false);
    var statusColumns = [{
      value: 0,
      text: '待处理'
    }, {
      value: 1,
      text: '进行中'
    }, {
      value: 2,
      text: '已逾期'
    }, {
      value: 3,
      text: '已完成'
    }, {
      value: -1,
      text: '已取消'
    }];
    // 设备类型
    var deviceModel = reactive({
      value: null,
      label: ''
    });
    var showDevicePicker = ref(false);
    var deviceColumns = ref([]);
    var oldScrollTop = ref(0);
    var loading = ref(true);
    var page = ref(1);
    var pageSize = ref(15);
    var totalPage = ref(0);
    var patrolGuardList = ref([]);
    var finished = ref(false);
    var listloading = ref(false);
    var beforePath = ref('');
    var beforePathObj = ref();
    var taskItem = ref();
    // const scrollTop = computed(() => {
    //   return store.getters['patrolGuard/getScrollTop'];
    // });
    var onRefresh = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              finished.value = false;
              _context.prev = 1;
              page.value = 1;
              _context.next = 5;
              return getList({
                inspectionUserName: inspectionUserName.value,
                deviceName: deviceName.value,
                deviceModel: deviceModel.value,
                taskType: taskType.value,
                status: taskStatus.value,
                taskName: searchVal.value
              });
            case 5:
              showToast('刷新成功');
              loading.value = false;
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              showToast('刷新失败');
              loading.value = false;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }));
      return function onRefresh() {
        return _ref.apply(this, arguments);
      };
    }();
    // const onClickLeft = () => {
    //   router.back();
    // };
    var onFilterSearch = function onFilterSearch() {
      filterModalShow.value = true;
    };
    var onSearchVal = function onSearchVal(value) {
      finished.value = false;
      page.value = 1;
      getList({
        taskName: value,
        inspectionUserName: inspectionUserName.value,
        deviceName: deviceName.value,
        deviceModel: deviceModel.value,
        taskType: taskType.value,
        status: taskStatus.value
      });
    };
    var onClear = function onClear(value) {
      finished.value = false;
      page.value = 1;
      getList({
        taskName: value,
        inspectionUserName: inspectionUserName.value,
        deviceName: deviceName.value,
        deviceModel: deviceModel.value,
        taskType: taskType.value,
        status: taskStatus.value
      });
    };
    var onTaskConfirm = function onTaskConfirm(value) {
      showTaskPicker.value = false;
      taskType.value = value.value;
      taskType.label = value.text;
    };
    var onClickCancel = function onClickCancel(item) {
      radioModalShow.value = true;
      customPopupType.value = '-1';
      taskItem.value = item;
    };
    var onClickDel = function onClickDel(item) {
      radioModalShow.value = true;
      customPopupType.value = '0';
      taskItem.value = item;
    };
    var onCancel = function onCancel(item) {
      radioModalShow.value = false;
      if (customPopupType.value === '1' || customPopupType.value === '0') {
        //
      }
    };
    var onOk = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res, delIndex;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(customPopupType.value == '-1')) {
                _context2.next = 7;
                break;
              }
              _context2.next = 3;
              return cancelPatrolGuard({
                id: Number(taskItem.value.id),
                status: -1
              });
            case 3:
              res = _context2.sent;
              if (res.status == '1') {
                showToast.success("\u53D6\u6D88\u6210\u529F");
                changeListStatus(-1, taskItem.value.id);
              } else {
                showToast("\u53D6\u6D88\u5931\u8D25");
              }
              _context2.next = 11;
              break;
            case 7:
              _context2.next = 9;
              return delPatrolGuard(taskItem.value.id);
            case 9:
              _res = _context2.sent;
              if (_res.status == '1') {
                showToast.success("\u5220\u9664\u6210\u529F");
                delIndex = unref(patrolGuardList).findIndex(function (item) {
                  return item.id == taskItem.value.id;
                });
                unref(patrolGuardList).splice(delIndex, 1);
              } else {
                showToast("\u5220\u9664\u5931\u8D25");
              }
            case 11:
              radioModalShow.value = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onOk() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onRest = function onRest() {
      //
      inspectionUserName.value = '';
      deviceName.value = '';
      deviceModel.label = '';
      deviceModel.value = null;
      taskType.label = '';
      taskType.value = null;
      taskStatus.label = '';
      taskStatus.value = null;
    };
    var onFilterOk = function onFilterOk() {
      filterModalShow.value = false;
      finished.value = false;
      page.value = 1;
      getList({
        inspectionUserName: inspectionUserName.value,
        deviceName: deviceName.value,
        deviceModel: deviceModel.value,
        taskType: taskType.value,
        status: taskStatus.value,
        taskName: searchVal.value
      });
    };
    var onFilterCancel = function onFilterCancel() {
      filterModalShow.value = false;
    };
    var onStatusConfirm = function onStatusConfirm(value) {
      //
      showStatusPicker.value = false;
      taskStatus.value = value.value;
      taskStatus.label = value.text;
    };
    var onDeviceConfirm = function onDeviceConfirm(value) {
      //
      showDevicePicker.value = false;
      deviceModel.value = value.dictValue;
      deviceModel.label = value.dictLabel;
    };
    var onComplete = function onComplete(row) {
      if (row.taskType == '保养计划') {
        router.push({
          path: '/patrolGuard/complete',
          query: {
            id: row.deviceId,
            taskItemId: row.taskItemId,
            status: 3
          }
        });
      } else if (row.taskType == '巡检计划') {
        router.push({
          path: '/addPatrolScheme',
          query: {
            id: row.deviceId,
            taskItemId: row.taskItemId,
            status: 3
          }
        });
      }
    };
    var onScrollHandle = function onScrollHandle(event) {
      // 滚动条距文档顶部的距离
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条滚动的距离
      var scrollStep = scrollTop - oldScrollTop.value;
      // console.log('header 滚动距离 ', scrollTop);
      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      store.commit('patrolGuard/setScrollTop', scrollTop);
    };
    var onLoad = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              listloading.value = true;
              _context3.next = 4;
              return getList({
                inspectionUserName: inspectionUserName.value,
                deviceName: deviceName.value,
                deviceModel: deviceModel.value,
                taskType: taskType.value,
                status: taskStatus.value,
                taskName: searchVal.value
              });
            case 4:
              listloading.value = false;
              _context3.next = 11;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              listloading.value = false;
              finished.value = true;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }));
      return function onLoad() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
        var _newList, res, data, records, pages, newList, newRecords;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              listloading.value = true;
              _context4.prev = 1;
              _context4.next = 4;
              return getPatrolGuard({
                pageIndex: page.value,
                pageSize: pageSize.value,
                t: params
              });
            case 4:
              res = _context4.sent;
              data = res.data;
              records = data.records, pages = data.pages;
              totalPage.value = pages;
              newList = _toConsumableArray(patrolGuardList.value);
              newRecords = records || [];
              if (page.value === 1) {
                newList = [];
              }
              (_newList = newList).push.apply(_newList, _toConsumableArray(records));
              if (page.value >= pages) {
                finished.value = true;
              }
              page.value = page.value + 1;
              patrolGuardList.value = newList;
              listloading.value = false;
              return _context4.abrupt("return", Promise.resolve());
            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](1);
              listloading.value = false;
              finished.value = true;
              return _context4.abrupt("return", Promise.reject());
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 19]]);
      }));
      return function getList(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var changeListStatus = function changeListStatus(status, id) {
      // 前端不请求更改列表数据
      patrolGuardList.value = unref(patrolGuardList).map(function (item) {
        var itemObj = _objectSpread({}, item);
        if ((item === null || item === void 0 ? void 0 : item.deviceId) == id) {
          itemObj.status = status;
        }
        return itemObj;
      });
    };
    // 获取设备类型
    var getDeviceTypeList = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, list;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return getDeviceType('device_type');
            case 2:
              data = _context5.sent;
              list = data.list;
              deviceColumns.value = list;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function getDeviceTypeList() {
        return _ref5.apply(this, arguments);
      };
    }();
    router.beforeEach(function (to, from) {
      beforePath.value = from.fullPath;
      beforePathObj.value = from;
      return true;
    });
    onMounted(function () {
      // 监听页面滚动事件
      document.documentElement.scrollTop = 0;
      window.addEventListener('scroll', onScrollHandle, {
        passive: true
      });
      console.log('初始化');
      getDeviceTypeList();
      getList({});
    });
    onUnmounted(function () {
      window.removeEventListener('scroll', onScrollHandle);
    });
    return function (_ctx, _cache) {
      var _component_van_search = _resolveComponent("van-search");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_search, {
        modelValue: _unref(searchVal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(searchVal) ? searchVal.value = $event : null;
        }),
        onSearch: onSearchVal,
        onClear: onClear,
        "show-action": "",
        placeholder: "搜索任务名称"
      }, {
        action: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "right-filter"
          }, [_createElementVNode("div", {
            onClick: onFilterSearch,
            class: "filter-text"
          }, "筛选"), _createElementVNode("img", {
            onClick: onFilterSearch,
            src: _imports_0
          })])];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_van_pull_refresh, {
        modelValue: _unref(loading),
        "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
          return _isRef(loading) ? loading.value = $event : null;
        }),
        onRefresh: onRefresh
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_list, {
            loading: _unref(listloading),
            "onUpdate:loading": _cache[17] || (_cache[17] = function ($event) {
              return _isRef(listloading) ? listloading.value = $event : null;
            }),
            "immediate-check": false,
            finished: _unref(finished),
            "finished-text": "没有更多了",
            onLoad: onLoad
          }, {
            default: _withCtx(function () {
              return [_createVNode(CollapseList, {
                listData: _unref(patrolGuardList),
                detailUrl: "/patrolGuard/detail"
              }, {
                footer: _withCtx(function (_ref6) {
                  var item = _ref6.item;
                  return [item.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), item.status == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true), item.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), item.status == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)) : _createCommentVNode("", true), item.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
                    plain: "",
                    type: "primary",
                    class: "footer-user-action",
                    onClick: _withModifiers(function () {
                      return onClickDel(item);
                    }, ["stop"])
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(" 删除 ")];
                    }),
                    _: 2
                  }, 1032, ["onClick"]), item.status == 1 || item.status == 0 || item.status == 2 ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    plain: "",
                    type: "primary",
                    class: "footer-user-action",
                    onClick: _withModifiers(function () {
                      return onClickCancel(item);
                    }, ["stop"])
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(" 取消 ")];
                    }),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true), item.status == 1 || item.status == 0 || item.status == 2 ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 1,
                    type: "primary",
                    onClick: _withModifiers(function () {
                      return onComplete(item);
                    }, ["stop"]),
                    class: "footer-user-action"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(" 完成 ")];
                    }),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true)])];
                }),
                _: 1
              }, 8, ["listData"]), _createVNode(_component_van_popup, {
                show: _unref(radioModalShow),
                "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
                  return _isRef(radioModalShow) ? radioModalShow.value = $event : null;
                }),
                position: "bottom",
                class: "filter-modal-show"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_19, [_unref(customPopupType) === '-1' ? (_openBlock(), _createElementBlock("span", _hoisted_20, "确定要取消吗？")) : _createCommentVNode("", true), _unref(customPopupType) === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_21, "确定要删除吗？")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_van_button, {
                    type: "default",
                    onClick: onCancel
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("取消")];
                    }),
                    _: 1
                  }), _createVNode(_component_van_button, {
                    type: "primary",
                    onClick: onOk
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("确定")];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              }, 8, ["show"]), _createVNode(_component_van_popup, {
                show: _unref(filterModalShow),
                "onUpdate:show": _cache[16] || (_cache[16] = function ($event) {
                  return _isRef(filterModalShow) ? filterModalShow.value = $event : null;
                }),
                position: "bottom",
                class: "filter-modal-show"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "filter-top"
                  }, [_hoisted_23, _hoisted_24, _createElementVNode("div", {
                    class: "filter-top-cancel",
                    onClick: onFilterCancel
                  }, "取消")]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_van_field, {
                    modelValue: _unref(deviceName),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _isRef(deviceName) ? deviceName.value = $event : null;
                    }),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createVNode(_component_van_field, {
                    modelValue: _unref(taskType).label,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(taskType).label = $event;
                    }),
                    "is-link": "",
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[4] || (_cache[4] = function ($event) {
                      return showTaskPicker.value = true;
                    })
                  }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                    show: _unref(showTaskPicker),
                    "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
                      return _isRef(showTaskPicker) ? showTaskPicker.value = $event : null;
                    }),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_picker, {
                        columns: taskColumns,
                        onCancel: _cache[5] || (_cache[5] = function ($event) {
                          return showTaskPicker.value = false;
                        }),
                        onConfirm: onTaskConfirm
                      })];
                    }),
                    _: 1
                  }, 8, ["show"])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createVNode(_component_van_field, {
                    modelValue: _unref(deviceModel).label,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                      return _unref(deviceModel).label = $event;
                    }),
                    "is-link": "",
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[8] || (_cache[8] = function ($event) {
                      return showDevicePicker.value = true;
                    })
                  }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                    show: _unref(showDevicePicker),
                    "onUpdate:show": _cache[10] || (_cache[10] = function ($event) {
                      return _isRef(showDevicePicker) ? showDevicePicker.value = $event : null;
                    }),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_picker, {
                        columns: _unref(deviceColumns),
                        "columns-field-names": {
                          text: 'dictLabel',
                          values: 'dictValue'
                        },
                        onCancel: _cache[9] || (_cache[9] = function ($event) {
                          return showDevicePicker.value = false;
                        }),
                        onConfirm: onDeviceConfirm
                      }, null, 8, ["columns"])];
                    }),
                    _: 1
                  }, 8, ["show"])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createVNode(_component_van_field, {
                    modelValue: _unref(taskStatus).label,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
                      return _unref(taskStatus).label = $event;
                    }),
                    "is-link": "",
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[12] || (_cache[12] = function ($event) {
                      return showStatusPicker.value = true;
                    })
                  }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                    show: _unref(showStatusPicker),
                    "onUpdate:show": _cache[14] || (_cache[14] = function ($event) {
                      return _isRef(showStatusPicker) ? showStatusPicker.value = $event : null;
                    }),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_picker, {
                        columns: statusColumns,
                        onCancel: _cache[13] || (_cache[13] = function ($event) {
                          return showStatusPicker.value = false;
                        }),
                        onConfirm: onStatusConfirm
                      })];
                    }),
                    _: 1
                  }, 8, ["show"])]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createVNode(_component_van_field, {
                    modelValue: _unref(inspectionUserName),
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
                      return _isRef(inspectionUserName) ? inspectionUserName.value = $event : null;
                    }),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_van_button, {
                    type: "default",
                    onClick: onRest
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("重置")];
                    }),
                    _: 1
                  }), _createVNode(_component_van_button, {
                    type: "primary",
                    onClick: onFilterOk
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("确定筛选")];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              }, 8, ["show"])];
            }),
            _: 1
          }, 8, ["loading", "finished"])];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
}));